var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4111 5.89822V20.2111C23.4111 21.3404 22.4956 22.2558 21.3663 22.2558H17.5324C17.2501 22.2558 17.0213 22.027 17.0213 21.7446V15.6105H19.4136C19.6565 15.6106 19.866 15.4396 19.9145 15.2016L20.2826 13.3614C20.2978 13.287 20.2792 13.2097 20.2318 13.1505C20.1843 13.0914 20.113 13.0561 20.0372 13.0547H17.0213V9.73203C17.0213 9.59088 17.1357 9.47644 17.2768 9.47644H19.8327C20.1151 9.47644 20.3439 9.24759 20.3439 8.96527V7.43175C20.3439 7.14943 20.1151 6.92057 19.8327 6.92057H17.2768C15.5829 6.92057 14.2097 8.29373 14.2097 9.98762V13.0547H12.9522C12.6698 13.0547 12.441 13.2835 12.441 13.5659V15.0994C12.441 15.3817 12.6698 15.6105 12.9522 15.6105H14.2097V21.7446C14.2097 22.027 13.9809 22.2558 13.6984 22.2558H7.05306C5.92377 22.2558 5.0083 21.3404 5.0083 20.2111V5.89822C5.0083 4.76896 5.92377 3.85352 7.05306 3.85352H21.3663C22.4956 3.85352 23.4111 4.76896 23.4111 5.89822Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.ad27ddf6b7638787ee9c730364e79454.svg";
export { ForwardRef as ReactComponent };